import { Avatar } from '../atoms'
import type { PlanHuntMember } from './types'

export function initialsOf(name: string | null | undefined): string {
  // Tolerates a null/absent name: the API sends no name for some roster entries
  // (older hunts especially), and a raw `.trim()` here crashed the whole page that
  // rendered the avatar. A missing name resolves to the "?" placeholder below.
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase()
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
}

export function PlanHuntAvatar({ member, size = 36 }: { member: PlanHuntMember; size?: number }) {
  return <Avatar initials={initialsOf(member.name)} photo={member.avatar ?? undefined} size={size} />
}
